import DatePicker from 'antd/es/date-picker';

const { RangePicker } = DatePicker;

export default RangePicker;
